import React from "react";
import { Select, SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../constants/AppConstants";
import SiteDesignStore from "../stores/SiteDesignStore";
import useStoreState from "./providers/useStoreState";

const { DISABLED_DIVIDER, SELECT_EMPTY_OPTION_TEXT, VALUE_THIS } = AppConstants;

const SiteBlockSelectInput = (props) => {
  const blocks = useStoreState(SiteDesignStore, SiteDesignStore.getSiteBlockList);

  return (
    <Select type="select" {...props}>
      <SelectOption value="">{SELECT_EMPTY_OPTION_TEXT}</SelectOption>
      <SelectOption value={VALUE_THIS}>This Site Canvas</SelectOption>
      <SelectOption disabled>{DISABLED_DIVIDER}</SelectOption>
      {blocks.map((block) => (
        <SelectOption key={block.get("id")} value={block.get("id")}>
          {block.get("name")}
        </SelectOption>
      ))}
    </Select>
  );
};

export default SiteBlockSelectInput;
